<div class="d-flex align-items-center container">
    <div [inlineSVG]="'assets/images/icons/youtube.svg'" [cacheSVG]="true" class="me-2 icon"></div>
    <a target="_blank" rel="noopener" [href]="href" [title]="title">{{ text }}</a>
</div>
